import { useState, useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router";
import "./CareerAssesment.css";
import { Button, Card, Col, Row, notification } from "antd";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import QuizIcon from "@mui/icons-material/Quiz";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useLocation } from "react-router-dom";
import axios from "axios";
import {
  AssesmentUrl,
  BaseUrl,
  getImageQuestion,
  getManualQuestion,
} from "../../Constants/Constants";
import { useStateValue } from "../../../Reducer/reducer";
import { actionTypes } from "../../../Reducer/StateProvider";

const CareerAssessment = () => {
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIconError = (type) => {
    api["error"]({
      message: "Oops!!!",
      description: type,
    });
  };

  const [courseName, setCourseName] = useState("");
  const [mcqid, setmcqId] = useState("");
  const [{ UserID }, dispatch] = useStateValue();
  const { id, assessmentId ,groupId} = useParams();
  const location = useLocation();

  const assessmentName = location.state?.assessment_name;
  const duration = location.state?.duration;
  const noOfQuestions = location.state?.no_of_questions;

  const profileDetails = JSON.parse(localStorage.getItem("Profile"));

  console.log(profileDetails, "profileDetails");

  const userId = profileDetails.user_id;

  console.log(id);
  const navigate = useNavigate();
  const [Data, setData] = useState("");
  const [Loading, setLoading] = useState(false);
  const [Questions, setQuestions] = useState({});
  let url = window.location.href;
  let splittedUrl = url.split("/")[6];
  const stringWithSpace = splittedUrl.replace(/-/g, " ");

  console.log(Data, "splittedUrl");

  useEffect(() => {
    let body = {
      courseId: id,
    };

    axios
      .post(`${BaseUrl}career-course-mapping/findOne`, body, {
        withCredentials: true,
      })

      .then((res) => {
        let response = res.data;

        if (response.statuscode === 200) {
          console.log(res.data.data[0], "courseDetails");
          setCourseName(res.data.data.title);
        } else {
          setCourseName("");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  useEffect(() => {
  setData({
    Assessment_name: assessmentName,
    Assesment_Duration: duration,
    Number_of_questions: noOfQuestions,
  });
}, [assessmentName, duration, noOfQuestions]);


  const handleTest = () => {
  setLoading(true);

  let Reqbody = {
    no_of_questions: String(Data?.Number_of_questions),   
    course_id: id,
    user_id: userId,
    assessment_id: assessmentId,
  };

  console.log("Career Dev Req Body:", Reqbody);

  axios
    .post(`${AssesmentUrl}get_career_dev_questions`, Reqbody)
    .then((res) => {
      console.log("Career Dev Questions:", res.data);

      // Save Questions
      setQuestions(res.data.generated_questions);

      dispatch({
        type: actionTypes.SET_Questions,
        Questions: res.data.generated_questions,
      });

      setLoading(false);

      navigate(`/career-program/group/${groupId}/course/${id}/assessment/${assessmentId}/mcq`, {
        state: {
          assessment_name: Data?.Assessment_name,
          duration: Data?.Assesment_Duration,
          no_of_questions: Data?.Number_of_questions,
        },
      });
    })
    .catch((err) => {
      console.log("Error getting questions:", err);
      openNotificationWithIconError("Error Getting Questions!");
      setLoading(false);
    });
};

  return (
    <div className="assessmentMainDiv">
      {contextHolder}

      {/* Breadcrumb Navigation */}
      <div className="assessmentBreadcrumb">
        <span
          className="breadcrumbLink"
          onClick={(e) => navigate(`/career-program`)}
        >
          Courses
        </span>
        <ArrowForwardIosIcon className="breadcrumbArrow" />
        {courseName && (
          <>
            <span
              className="breadcrumbLink"
              onClick={(e) => navigate(`/career-program/group/${groupId}/course/${id}`)}
            >
              {courseName}
            </span>
            <ArrowForwardIosIcon className="breadcrumbArrow" />
          </>
        )}
        <span className="breadcrumbCurrent">
          {Data?.Assessment_name || "Assessment"}
        </span>
      </div>

      {/* Main Content Container */}
      <div className="assessmentContainer">
        {/* Left Side - Assessment Info */}
        <div className="assessmentInfoSection">
          <div className="assessmentHeader">
            <div className="assessmentIconWrapper">
              <AutoAwesomeIcon className="assessmentIcon" />
            </div>
            <h1 className="assessmentTitle">
              {Data?.Assessment_name || "Assessment"}
            </h1>
            <p className="assessmentSubtitle">
              Ready to test your knowledge? Let's begin your assessment journey.
            </p>
          </div>

          <Card className="assessmentDetailsCard">
            <div className="assessmentDetailItem">
              <div className="detailIconWrapper">
                <EditNoteOutlinedIcon className="detailIcon" />
              </div>
              <div className="detailContent">
                <span className="detailLabel">Assessment Type</span>
                <span className="detailValue">MCQ Assessment</span>
              </div>
            </div>

            <div className="assessmentDetailItem">
              <div className="detailIconWrapper timeIcon">
                <AccessTimeIcon className="detailIcon" />
              </div>
              <div className="detailContent">
                <span className="detailLabel">Duration</span>
                <span className="detailValue">
                  {Data?.Assesment_Duration || "N/A"} minutes
                </span>
              </div>
            </div>

            <div className="assessmentDetailItem">
              <div className="detailIconWrapper questionIcon">
                <QuizIcon className="detailIcon" />
              </div>
              <div className="detailContent">
                <span className="detailLabel">Total Questions</span>
                <span className="detailValue">
                  {Data?.Number_of_questions || "N/A"} questions
                </span>
              </div>
            </div>

            {Data && Data.assessment_type === "mcq with description" && (
              <div className="assessmentNote">
                <AutoAwesomeIcon className="noteIcon" />
                <p>
                  Your score will be based on the answer along with the
                  description provided
                </p>
              </div>
            )}
          </Card>
        </div>

        {/* Right Side - Visual & Action */}
        <div className="assessmentActionSection">
          <div className="assessmentVisualWrapper">
            <div className="gradientOrb orb1"></div>
            <div className="gradientOrb orb2"></div>
            <div className="gradientOrb orb3"></div>
            <div className="assessmentImageContainer">
              <img
                src="/icons/exam.png"
                alt="Assessment"
                className="assessmentImage"
              />
            </div>
          </div>

          <Button
            loading={Loading}
            disabled={Loading}
            onClick={handleTest}
            className="startTestButton"
            icon={<PlayArrowIcon />}
            size="large"
          >
            {Loading ? "Preparing Assessment..." : "Start Assessment"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CareerAssessment;
